/* js/form.js */

;(function ($, window, document) {

    /**
     * function to display placeholder for internet explorer 8+9
     */

    $.fn.ToggleInputValue = function () {
        return $(this).each(function () {
            var Input = $(this);
            var default_value = Input.attr("placeholder");
            Input.val(default_value);

            Input.focus(function () {
                if (Input.val() == default_value) Input.val("");
            }).blur(function () {
                if (Input.val().length === 0) Input.val(default_value);
            });
        });
    }

    /**
     * function clears the default values
     */
    $.fn.ClearDevalt = function () {
        return $(this).each(function () {
            var Input = $(this);
            var default_value = Input.attr("placeholder");
            if (Input.val() == default_value) Input.val("");
        });
    }

    $(window).on('load', function () {
        $('#contactform input[type=text], #contactform input[type=email], #contactform textarea').ToggleInputValue();
        $('#contactform').submit(function () {
            $('#contactform input[type=text], #contactform input[type=email], #contactform textarea').ClearDevalt();
        });


        /**
         * Hover effect for text-widgets
         */

        var $target = $('.widget-text input, .widget-password input, .widget-textarea textarea');

        $target.focusin(function () {
            $(this).parent().addClass('is--focused');
        });

        $target.focusout(function () {
            $(this).parent().removeClass('is--focused');
        });

    });

})(jQuery, window, document);